export default "__VITE_ASSET__DclwnVXy__"